<div *ngIf="!!(isPageLoading$ | async)" id="spinner-modal" class="progress-spinner">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
</div>